import { render, staticRenderFns } from "./AddLocation.vue?vue&type=template&id=68b124e7&scoped=true&"
import script from "./AddLocation.vue?vue&type=script&lang=js&"
export * from "./AddLocation.vue?vue&type=script&lang=js&"
import style0 from "./AddLocation.vue?vue&type=style&index=0&id=68b124e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b124e7",
  null
  
)

export default component.exports